import type { Api } from "../../../data/api";

/**
 * „Neu seit dem letzten Besuch“ (TA-125, AD-192) ohne den übrigen Kalender: Markierung im Kalender und Zähler am Menüpunkt
 * (PARITAET-19) nutzen dieselbe Regel. Klein gehalten, damit der Rahmen der Portale nicht den ganzen Kalender lädt.
 */
type Seite = "agentur" | "creator";
interface TerminKopf { id: string; source_key: string | null; created_by_side: string | null; created_at: string; updated_at: string }

/** Termine der anderen Seite, die seit dem letzten Besuch neu sind oder geändert wurden (automatische Einträge nie). */
export function neuSeit(termine: readonly TerminKopf[], seit: string | null, p: Seite): Set<string> {
  const grenze = seit ? Date.parse(seit) : NaN;
  if (!Number.isFinite(grenze)) return new Set();
  const andere = p === "creator" ? "agency" : "talent";
  return new Set(termine
    .filter((t) => !t.source_key && t.created_by_side === andere && Math.max(Date.parse(t.updated_at) || 0, Date.parse(t.created_at) || 0) > grenze)
    .map((t) => t.id));
}

/** Merkschlüssel des letzten Besuchs: je Mitgliedschaft (Team) bzw. je Creator-Profil */
export function kalenderMerkKey(id: string): string {
  return `tk-kalender-gesehen:${id}`;
}

/** Zeitpunkt des letzten Besuchs aus dem Browser; ohne Speicher (privates Fenster) null */
export function letzterBesuch(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

/** Zähler am Menüpunkt Kalender: neue bzw. geänderte Termine der anderen Seite seit dem letzten Besuch; ohne Besuch 0 */
export async function zaehleNeueTermine(api: Api, a: { orgId: string; perspektive: Seite; seit: string | null }): Promise<number> {
  if (!a.seit || !Number.isFinite(Date.parse(a.seit))) return 0;
  const rows = await api.select<TerminKopf>("calendar_events", {
    columns: "id, source_key, created_by_side, created_at, updated_at",
    filters: [["org_id", "eq", a.orgId], ["updated_at", "gt", a.seit]],
  }).catch(() => [] as TerminKopf[]);
  return neuSeit(rows, a.seit, a.perspektive).size;
}
